import { articles } from '@/mocks/articles';
import ArticleCard from '@/components/base/ArticleCard';

export default function LatestSection() {
  const latestArticles = articles.filter(
    (a) => a.category === 'latest' || a.category === 'new-face'
  ).slice(0, 8);

  return (
    <section className="w-full px-4 md:px-6 py-12 md:py-16 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-xl md:text-2xl font-bold font-heading text-foreground-900">
              最新发布
            </h2>
            <p className="text-sm text-foreground-500 mt-1">每日更新，第一时间获取最新番号</p>
          </div>
          <a
            href="/category/latest"
            className="flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 transition-colors cursor-pointer whitespace-nowrap"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {latestArticles.map((article) => (
            <ArticleCard key={article.id} {...article} />
          ))}
        </div>
      </div>
    </section>
  );
}